import { ComponentConfig } from '@measured/puck';

import { convertMarkdown } from '../../../../utils/convert-markdown';

type MarkdownBlockProps = {
  content: string;
};

const MarkdownBlock: ComponentConfig<MarkdownBlockProps> = {
  defaultProps: {
    content: 'This is a _markdown_ block. It allows **rich** text formatting.',
  },
  fields: {
    content: {
      type: 'textarea',
    },
  },
  label: 'Markdown',
  render: ({ content }: MarkdownBlockProps) => {
    const renderedText = convertMarkdown(content);
    return <div className="prose text-typography" dangerouslySetInnerHTML={{ __html: renderedText }} />;
  },
};

export { MarkdownBlock };
